import * as Sentry from "@sentry/react";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./utils/fixThumbnailUrls.ts";
import { convex } from "@/lib/convexClient";
import { configureConsoleLogging } from "@/lib/consoleLogging";

configureConsoleLogging();

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (import.meta.env.DEV) {
  console.info("[Sentry] DSN loaded:", sentryDsn ? "yes" : "no");
}
Sentry.init({
  dsn: sentryDsn,
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
  replaysSessionSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 0.0,
  enabled: Boolean(sentryDsn),
});
if (import.meta.env.DEV) {
  (window as typeof window & { Sentry?: typeof Sentry }).Sentry = Sentry;
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <ConvexAuthProvider client={convex}>
    <App />
  </ConvexAuthProvider>,
);
